// eslint-disable-next-line
import React, { useState, useEffect } from "react";
import queryString from 'query-string';
import { makeStyles } from "@material-ui/core/styles";
import SelectScopeMenu from "../selectScope/SelectScopeMenu.jsx";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import {Snackbar} from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { history } from "../../_redux/_store/history";
import { createNewScopedFinding } from "../../_redux/_actions/scopedFindingRuleActions";
import { useDispatch, useSelector } from "react-redux";
import ErrorHandler from "../updateHandlers/ErrorHandler";

const useStyles = makeStyles(() => ({
  Button: {
    width: "120px",
    marginRight: "20px",
    "&:hover": {
      background: "#52A1C2",
    },
  },
  helpIcon: {
    marginBottom: "10px",
    marginLeft: "0.5px",
    width: "20px",
  },
  CancelIcon: {
    "&:hover": {
      background: null,
    },
  },
}));

export default function CreateScope({ open, onClose,setCreateScopedFindingSuccess,setCreateScopedFindingFailure }) {
  const classes = useStyles();
  const [noteText, setNoteText] = useState("");
  const [newScope, setNewScope] = useState("");
  const [error, setError] = useState(false);
  const [createRuleError, setCreateRuleError] = useState(false);
  const queryValues = queryString.parse(history.location.search);
  const findingRuleId = queryValues.findingRuleId;
  const {machine_type, hmi_type} = queryValues
  const dispatch = useDispatch();

  const getScopeData = (scopeData) => {
    setNewScope(scopeData);
  };

  const handleNoteTextChange = (value) => {
    setNoteText(value);
  };

  const scopedFindingRuleResponse = useSelector(
    (state) => state.scopedFindingRule
  )

  const updateNewScopedFindingRule = () => {
      const body = {
        finding_rule_id: findingRuleId,
        scope: !newScope ? 'global:' : newScope,
        note_text: noteText,
      };
      dispatch(createNewScopedFinding(body, machine_type,hmi_type,handleCreateScopedFindingRule));
      onClose();
  };

  const handleCreateScopedFindingRule=(val)=>{
    if(val){
      setCreateScopedFindingSuccess(
        {findingRuleId: findingRuleId,
        scope: !newScope ? 'global:' : newScope})
    }
    else{
      setCreateScopedFindingFailure(true)
    }
  }

  return (
    <Grid>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={"md"}
        PaperProps={{
          style: { width: "1000px", height: "450px", padding: "5px" },
        }}
      >
        <DialogContent style={{ overflow: "hidden" }}>
          <Grid item container direction="column" justifyContent="center">
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              style={{ marginBottom: "2em", marginTop: "1em" }}
            >
              <Grid item>
                <Typography style={{ color: "#52A1C2", fontWeight: 700 }}>
                  New Scoped Finding Rule
                </Typography>
              </Grid>
              <Grid item>
                <Button onClick={onClose}>
                  <CancelIcon
                    style={{ color: "#666666" }}
                    className={classes.CancelIcon}
                  />
                </Button>
              </Grid>
            </Grid>
            <Grid item style={{ marginBottom: "2em" }}>
              <TextField
                fullWidth
                label="Add Note Text for Scoped Finding Rule"
                multiline
                maxRows={4}
                onChange={(e) => handleNoteTextChange(e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item style={{ marginBottom: "20px" }}>
              <Typography>
                Select a scope and proceed to configure the parameters
              </Typography>
            </Grid>
            <Grid item container>
              <SelectScopeMenu getScopeData={getScopeData} />
            </Grid>
            <Grid
              container
              direction="row"
              style={{ marginBottom: "20px", marginTop: "30px" }}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  className={classes.Button}
                  onClick={() => updateNewScopedFindingRule()}
                >
                  Done
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  className={classes.Button}
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Snackbar
          message={error}
          open={error ? true : false}
          onClose={() => setError(false)}
          autoHideDuration={2000}
      />
      {createRuleError && (
        <ErrorHandler message={scopedFindingRuleResponse.error} />
      )}

    </Grid>
  );
}

 {/* Pop up to show if the create scoped finding rule has been successful */}

  export const CreateScopeSuccess = ({open,setCreateScopedFindingSuccess,value})=>{
  const classes = useStyles();
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues
  const handleSuccess=()=>{    
    setCreateScopedFindingSuccess(false)
    history.push(
      `/rules/select_finding_rule/select_scope/scoped_finding_rule_configuration?machine_type=${machine_type}&hmi_type=${hmi_type}&findingRuleId=${value.findingRuleId}&scope=${value.scope}`
    );
  }
  return(
  <Grid>
    <Dialog
        open={open}
        maxWidth={"md"}
        PaperProps={{ style: { width: "40em", height: "20em" } }}
      >
        <DialogContent style={{ padding: "30px" }}>
          <Grid
            item
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <CheckCircleOutlineIcon
                style={{ width: "3em", height: "3em", color: "#52A1C2" }}
              />
            </Grid>
            <Grid item style={{ marginTop: "20px", marginBottom: "20px" }}>
              New Scoped Finding Rule has been created successfully
            </Grid>
            <Grid item>
              <Button
                onClick={() =>handleSuccess()}
                className={classes.Button}
                variant="outlined"
              >
                <Typography>OK</Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
    </Dialog>
  </Grid>
  )
}